export default __webpack_public_path__ + "static/media/so-v.af799f54.svg";